import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupIntersect3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"boolean-group-intersect-3"} maskId="square-filled-radius-0-stroke-1-IconBooleanGroupIntersect3"><path d="M11 8H16V13H15V9H11V8Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M8 2H22V16H16V22H2V8H8V2ZM9 15H21V3H9V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBooleanGroupIntersect3;
